import React from 'react';
import { useLocation } from 'react-router-dom';
import { SettingsIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const { user } = React.useContext(AuthenticationContext);

  const isAdminUser = user?.modules?.some((module) => module.value === 'admin' && parseInt(module.tier) > 2);

  const navigationItems = [];

  if (isAdminUser) {
    navigationItems.push({
      label: 'Admin',
      url: '/admin/user_management',
      icon: SettingsIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/admin/app_modules',
          disabled: false,
          label: 'App Modules',
        },
        {
          url: '/admin/manufacturers',
          disabled: false,
          label: 'Manufacturers',
        },
        {
          url: '/admin/module_updates',
          disabled: false,
          label: 'Module Updates',
        },
        {
          url: '/admin/notification_settings',
          disabled: false,
          label: 'Notification Settings',
        },
        {
          url: '/admin/teams',
          disabled: false,
          label: 'Teams',
        },
        {
          url: '/admin/user_management',
          disabled: false,
          label: 'User Management',
        },
      ],
    });
  }

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default AdminSidebar;
